/* ELYT cart upsell */
(function () {
  if (window.__elytUpsellBound) return;
  window.__elytUpsellBound = true;

  function showError(button, message) {
    var box = button.closest('.elyt-cart-upsell');
    var el = box && box.querySelector('.elyt-upsell-error');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 5000);
  }

  async function refreshCart() {
    var res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!res.ok) throw new Error('Could not retrieve cart');
    var cart = await res.json();
    try {
      var events = await import('@theme/events');
      document.dispatchEvent(
        new events.CartUpdateEvent(cart, 'elyt-upsell', {
          itemCount: cart.item_count,
          source: 'elyt-upsell'
        })
      );
    } catch (e) {
      window.location.reload();
    }
  }

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('.elyt-upsell-button');
    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    var variantId = Number(button.dataset.elytVariantId);
    if (!variantId) {
      console.error('ELYT upsell: button has no variant id', button);
      return;
    }

    var original = button.textContent;
    button.disabled = true;
    button.textContent = '…';

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      var result = await response.json().catch(function () { return {}; });
      if (!response.ok) {
        throw new Error(result.description || result.message || 'Could not add this item');
      }
      button.textContent = '✓';
      await refreshCart();
    } catch (error) {
      console.error('ELYT upsell error:', error);
      showError(button, error.message);
      button.disabled = false;
      button.textContent = original || '+';
    }
  }, true);
})();